import styled from 'styled-components'
import theme from '../../styles/theme'
export const ProcessCardContanier = styled.div``

export const CardTitle = styled.div`
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: ${theme.color.black};
  padding: 16px 0 0 0;
`

export const ProcessCardWrapper = styled.div`
  position: relative;
`

export const ProcessLine = styled.div`
  position: absolute;
  width: 0px;
  height: 210px;
  left: 21px;
  top: 20px;
  z-index: -1;
  border: 3px solid ${theme.color.bgAlt};
`

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px 0 30px 0;
`

export const ProcessIcon = styled.img``

export const ProcessText = styled.p`
  padding: 0 0 0 14px;
  margin-bottom: 0rem;
`
